import { api } from "@/src/core/api/client";
import { setProfile } from "@/src/core/auth/session";

interface IProfileResponse {
  data?: Record<string, unknown> | null;
}

/** Reloads the signed-in user's profile into the session; null when the request fails. */
export const refreshProfile = async (): Promise<Record<
  string,
  unknown
> | null> => {
  try {
    const { data } = await api.laravel.get<IProfileResponse>("/auth/profile");
    if (data.data) setProfile(data.data);
    return data.data ?? null;
  } catch {
    return null;
  }
};
